// START constants
export const SUBJECTS = {
  math: 'matematika',
  inform: 'informatika',
  rus: 'russkij-yazyk',
  liter: 'literatura',
  fizika: 'fizika',
  himiya: 'himiya',
  biology: 'biologiya',
  okr: 'okruzhayushchij-mir',
  geografiya: 'geografiya',
  istoriya: 'istoriya',
  obsh: 'obshchestvoznanie',
  anglisky: 'anglijskij_yazyk',
  german: 'nemezkij-yazyk',
  spanish: 'ispanskij-yazyk',
  chinese: 'kitajskij-yazyk',
};

const TARGET = {
  podtyanut: 'podtyanut-znaniya',
  dz: 'pomoch-s-dz',
  ege: 'ege',
  oge: 'oge',
  olympiada: 'olympiada',
  vpr: 'vpr',
  free: 'free',
};
// END constants

// START list
export const subjectList = [
  { id: 'all', title: 'Все предметы' },
  { id: SUBJECTS.math, title: 'Математика', forTitle: 'Математике' },
  { id: SUBJECTS.inform, title: 'Информатика', forTitle: 'Информатике' },
  { id: SUBJECTS.rus, title: 'Русский', forTitle: 'Русскому языку' },
  { id: SUBJECTS.liter, title: 'Литература', forTitle: 'Литературе' },
  { id: SUBJECTS.fizika, title: 'Физика', forTitle: 'Физике' },
  { id: SUBJECTS.himiya, title: 'Химия', forTitle: 'Химии' },
  { id: SUBJECTS.biology, title: 'Биология', forTitle: 'Биологии' },
  { id: SUBJECTS.okr, title: 'Окружающий мир', forTitle: 'Окружающему миру' },
  { id: SUBJECTS.geografiya, title: 'География', forTitle: 'Географии' },
  { id: SUBJECTS.istoriya, title: 'История', forTitle: 'Истории' },
  { id: SUBJECTS.obsh, title: 'Обществознание', forTitle: 'Обществознанию' },
  { id: SUBJECTS.anglisky, title: 'Английский', forTitle: 'Английскому языку' },
  { id: SUBJECTS.german, title: 'Немецкий', forTitle: 'Немецкому языку' },
  { id: SUBJECTS.spanish, title: 'Испанский', forTitle: 'Испанскому языку' },
  { id: SUBJECTS.chinese, title: 'Китайский', forTitle: 'Китайскому языку' },
];

export const targetList = [
  { id: 'all', title: 'Все цели' },
  { id: TARGET.podtyanut, title: 'Подтянуть знания', forTitle: 'подтянуть знания' },
  { id: TARGET.dz, title: 'Помощь с д/з', forTitle: 'сделать домашнее задание' },
  { id: TARGET.ege, title: 'Подготовка к ЕГЭ', forTitle: 'подготовиться к ЕГЭ' },
  { id: TARGET.oge, title: 'Подготовка к ОГЭ', forTitle: 'подготовиться к ОГЭ' },
  { id: TARGET.olympiada, title: 'Олимпиада', forTitle: 'подготовиться к Олимпиаде' },
  { id: TARGET.vpr, title: 'ВПР', forTitle: 'подготовиться к ВПР' },
  { id: TARGET.free, title: 'Бесплатно', forTitle: 'заниматься бесплатно' },
];

export const gradeList = Array(11).fill('').map((i, index) => ({
  id: `${index + 1}-class`,
  title: `${index + 1} класс`,
}));
gradeList.unshift({ id: 'all', title: 'Все классы' });
// END list

// START factory
const priceByLessons = {
  4: { lesson: 1500, all: 6000, discount: 0 },
  8: { lesson: 1400, all: 11200, discount: 6 },
  16: { lesson: 1300, all: 20800, discount: 13 },
  32: { lesson: 1200, all: 38400, discount: 20 },
  64: { lesson: 1100, all: 70400, discount: 26 },
  96: { lesson: 1000, all: 96000, discount: 33 },
};

const listByLessons = {
  4: [
    'Акцент на&nbsp;самых важных аспектах предмета и только нужные знания',
    'Помощь с д/з, подготовка к проверочным работам',
    'Преподаватель с высшей категорией и экспертным уровнем МЦКО',
    'Индивидуальное расписание занятий с возможностью отмены и переноса без потери урока',
  ],
  8: [
    'Более углубленное изучение предмета, устранение пробелов в знаниях',
    'Подготовка к проверочным работам и экзаменам',
    'Подготовка победителей и призёров ВОШ',
    'Преподаватель с высшей категорией и экспертным уровнем МЦКО',
    'Индивидуальное расписание занятий',
  ],
  16: [
    'Освоение сложных тем и&nbsp;удержание высоких показателей в&nbsp;учебе ',
    'Начальная подготовка к&nbsp;государственным экзаменам',
    'Подготовка победителей и призёров ВОШ',
    'Преподаватель с высшей категорией и экспертным уровнем МЦКО',
    'Индивидуальное расписание занятий',
  ],
  32: [
    'Обширное изучение предмета и подготовка на&nbsp;высоком уровне',
    'Подготовка к проверочным работам и экзаменам',
    'Подготовка победителей и призёров ВОШ',
    'Преподаватель с высшей категорией и экспертным уровнем МЦКО',
    'Индивидуальное расписание занятий',
  ],
  64: [
    'Максимальное овладевание предметом до уровня эксперта в области',
    'Подготовка к проверочным работам и экзаменам',
    'Подготовка победителей и призёров ВОШ',
    'Преподаватель с высшей категорией и экспертным уровнем МЦКО',
    'Консультация с профориентологом и психологом',
  ],
  96: [
    'Полное и&nbsp;исчерпывающее обучение до экспертности в&nbsp;области',
    'Вы сможете уверенно применять знания на практике',
    'Подготовка победителей и призёров ВОШ',
    'Преподаватель с высшей категорией и экспертным уровнем МЦКО',
    'Консультация с профориентологом и психологом',
  ],
  exam: [
    'Лучшие преподаватели онлайн-школы «Синергия»',
    'Индивидуальное расписание занятий с возможностью отмены и переноса без потери урока',
    'Персональный план обучения, учитывающий уровень знаний и цель в баллах',
    'Уроки по 40 минут с погружением в теорию и решением заданий на практике',
  ],
};

const getCheap = (withVpr) => [
  { id: TARGET.podtyanut, text: 'Подтянуть знания', colored: true },
  ...withVpr ? [{ id: TARGET.vpr, text: 'ВПР', colored: true }] : [],
  { id: TARGET.dz, text: 'Домашки', colored: true },
  { id: TARGET.olympiada, text: 'Олимпиада', colored: true },
];
// END factory

// START templates
const templateMath = {
  subject: SUBJECTS.math,
  name: 'Олег германович',
  cheap: [
    { text: '1–11 класс', colored: false },
    ...getCheap(true),
  ],
  classes: { from: 1, to: 11 },
};

const templateFizika = {
  subject: SUBJECTS.fizika,
  cheap: [
    { text: '6–11 класс', colored: false },
    ...getCheap(true),
  ],
  classes: { from: 6, to: 11 },
};

const templateRus = {
  subject: SUBJECTS.rus,
  name: 'Екатерина тупицына',
  cheap: [
    { text: '1–11 класс', colored: false },
    ...getCheap(true),
  ],
  classes: { from: 1, to: 11 },
};

const templateHistory = {
  subject: SUBJECTS.istoriya,
  name: 'Мардон Модебадзе',
  cheap: [
    { text: '5–11 класс', colored: false },
    ...getCheap(true),
  ],
  classes: { from: 5, to: 11 },
};

const templateObsh = {
  subject: SUBJECTS.obsh,
  cheap: [
    { text: '5–11 класс', colored: false },
    ...getCheap(true),
  ],
  classes: { from: 5, to: 11 },
};

const templateGeografiya = {
  subject: SUBJECTS.geografiya,
  name: 'Наиля алимова',
  cheap: [
    { text: '5–11 класс', colored: false },
    ...getCheap(true),
  ],
  classes: { from: 5, to: 11 },
};

const templateBiology = {
  subject: SUBJECTS.biology,
  name: 'Елена тетяйкина',
  cheap: [
    { text: '5–11 класс', colored: false },
    ...getCheap(true),
  ],
  classes: { from: 5, to: 11 },
};

const templateHimiya = {
  subject: SUBJECTS.himiya,
  name: 'Елена тетяйкина',
  cheap: [
    { text: '7–11 класс', colored: false },
    ...getCheap(true),
  ],
  classes: { from: 7, to: 11 },
};

const templateAnglisky = {
  subject: SUBJECTS.anglisky,
  cheap: [
    { text: '1–11 класс', colored: false },
    ...getCheap(true),
  ],
  classes: { from: 1, to: 11 },
};

const templateInform = {
  subject: SUBJECTS.inform,
  name: 'Александр Громов',
  cheap: [
    { text: '5–11 класс', colored: false },
    ...getCheap(false),
  ],
  classes: { from: 5, to: 11 },
};

const templateLiter = {
  subject: SUBJECTS.liter,
  cheap: [
    { text: '1–11 класс', colored: false },
    ...getCheap(false),
  ],
  classes: { from: 1, to: 11 },
};

const templateSpanish = {
  subject: SUBJECTS.spanish,
  name: 'Маргарита Корнеева',
  cheap: [
    { text: '5–11 класс', colored: false },
    ...getCheap(false),
  ],
  classes: { from: 5, to: 11 },
};

const templateGerman = {
  subject: SUBJECTS.german,
  name: 'Елена алешина',
  cheap: [
    { text: '5–11 класс', colored: false },
    ...getCheap(false),
  ],
  classes: { from: 5, to: 11 },
};

const templateChinese = {
  subject: SUBJECTS.chinese,
  name: 'Адель Саттарова',
  cheap: [
    { text: '5–11 класс', colored: false },
    ...getCheap(false),
  ],
  classes: { from: 5, to: 11 },
};

const templateOkr = {
  subject: SUBJECTS.okr,
  name: 'Анна котова',
  cheap: [
    { text: '1–4 класс', colored: false },
    ...getCheap(false),
  ],
  classes: { from: 1, to: 4 },
};

export const subjectTemplates = [
  templateMath,
  templateFizika,
  templateRus,
  templateHistory,
  templateObsh,
  templateGeografiya,
  templateBiology,
  templateHimiya,
  templateAnglisky,
  templateInform,
  templateLiter,
  templateSpanish,
  templateGerman,
  templateChinese,
  templateOkr,
];
// END templates

export const cards = [
  {
    ...templateMath,
    image: 'oleg/1',
    title: 'Математика 4&nbsp;урока',
    price: priceByLessons[4],
    textItems: listByLessons[4],
  },
  {
    ...templateMath,
    image: 'oleg/2',
    title: 'Математика 8&nbsp;уроков',
    price: priceByLessons[8],
    textItems: listByLessons[8],
  },
  {
    ...templateMath,
    image: 'oleg/3',
    title: 'Математика 16&nbsp;уроков',
    price: priceByLessons[16],
    textItems: listByLessons[16],
  },
  {
    ...templateMath,
    image: 'oleg/4',
    title: 'Математика 32&nbsp;урока',
    price: priceByLessons[32],
    textItems: listByLessons[32],
  },
  {
    ...templateMath,
    image: 'oleg/1',
    title: 'Математика 64&nbsp;урока',
    price: priceByLessons[64],
    textItems: listByLessons[64],
    additionConsult: true,
  },
  {
    ...templateMath,
    image: 'oleg/2',
    title: 'Математика 96&nbsp;уроков',
    price: priceByLessons[96],
    textItems: listByLessons[96],
    additionConsult: true,
  },

  {
    ...templateFizika,
    image: 'kris/1',
    name: 'Кристина линькова',
    title: 'физика 4&nbsp;урока',
    price: priceByLessons[4],
    textItems: listByLessons[4],
  },
  {
    ...templateFizika,
    image: 'alex/1',
    name: 'Александр громов',
    title: 'физика 8&nbsp;уроков',
    price: priceByLessons[8],
    textItems: listByLessons[8],
  },
  {
    ...templateFizika,
    image: 'alex/2',
    name: 'Александр громов',
    title: 'физика 16&nbsp;уроков',
    price: priceByLessons[16],
    textItems: listByLessons[16],
  },
  {
    ...templateFizika,
    image: 'kris/1',
    name: 'Кристина линькова',
    title: 'физика 32&nbsp;урока',
    price: priceByLessons[32],
    textItems: listByLessons[32],
  },
  {
    ...templateFizika,
    image: 'alex/3',
    name: 'Александр громов',
    title: 'физика 64&nbsp;урока',
    price: priceByLessons[64],
    textItems: listByLessons[64],
    additionConsult: true,
  },
  {
    ...templateFizika,
    image: 'kris/1',
    name: 'Кристина линькова',
    title: 'физика 96&nbsp;уроков',
    price: priceByLessons[96],
    textItems: listByLessons[96],
    additionConsult: true,
  },

  {
    ...templateRus,
    image: 'katya/1',
    title: 'Русский язык 4&nbsp;урока',
    price: priceByLessons[4],
    textItems: listByLessons[4],
  },
  {
    ...templateRus,
    image: 'katya/2',
    title: 'Русский язык 8&nbsp;уроков',
    price: priceByLessons[8],
    textItems: listByLessons[8],
  },
  {
    ...templateRus,
    image: 'katya/3',
    title: 'Русский язык 16&nbsp;уроков',
    price: priceByLessons[16],
    textItems: listByLessons[16],
  },
  {
    ...templateRus,
    image: 'katya/4',
    title: 'Русский язык 32&nbsp;урока',
    price: priceByLessons[32],
    textItems: listByLessons[32],
  },
  {
    ...templateRus,
    image: 'katya/1',
    title: 'Русский язык 64&nbsp;урока',
    price: priceByLessons[64],
    textItems: listByLessons[64],
    additionConsult: true,
  },
  {
    ...templateRus,
    image: 'katya/2',
    title: 'Русский язык 96&nbsp;уроков',
    price: priceByLessons[96],
    textItems: listByLessons[96],
    additionConsult: true,
  },

  {
    ...templateHistory,
    image: 'mardon/1',
    title: 'история 4&nbsp;урока',
    price: priceByLessons[4],
    textItems: listByLessons[4],
  },
  {
    ...templateHistory,
    image: 'mardon/2',
    title: 'история 8&nbsp;уроков',
    price: priceByLessons[8],
    textItems: listByLessons[8],
  },
  {
    ...templateHistory,
    image: 'mardon/3',
    title: 'история 16&nbsp;уроков',
    price: priceByLessons[16],
    textItems: listByLessons[16],
  },
  {
    ...templateHistory,
    image: 'mardon/4',
    title: 'история 32&nbsp;урока',
    price: priceByLessons[32],
    textItems: listByLessons[32],
  },
  {
    ...templateHistory,
    image: 'mardon/1',
    title: 'история 64&nbsp;урока',
    price: priceByLessons[64],
    textItems: listByLessons[64],
    additionConsult: true,
  },
  {
    ...templateHistory,
    image: 'mardon/2',
    title: 'история 96&nbsp;уроков',
    price: priceByLessons[96],
    textItems: listByLessons[96],
    additionConsult: true,
  },

  {
    ...templateObsh,
    image: 'andrey/1',
    name: 'Андрей аксёнов',
    title: 'обществознание 4&nbsp;урока',
    price: priceByLessons[4],
    textItems: listByLessons[4],
  },
  {
    ...templateObsh,
    image: 'mardon/1',
    name: 'Мардон Модебадзе',
    title: 'обществознание 8&nbsp;уроков',
    price: priceByLessons[8],
    textItems: listByLessons[8],
  },
  {
    ...templateObsh,
    image: 'andrey/1',
    name: 'Андрей аксёнов',
    title: 'обществознание 16&nbsp;уроков',
    price: priceByLessons[16],
    textItems: listByLessons[16],
  },
  {
    ...templateObsh,
    image: 'mardon/2',
    name: 'Мардон Модебадзе',
    title: 'обществознание 32&nbsp;урока',
    price: priceByLessons[32],
    textItems: listByLessons[32],
  },
  {
    ...templateObsh,
    image: 'andrey/1',
    name: 'Андрей аксёнов',
    title: 'обществознание 64&nbsp;урока',
    price: priceByLessons[64],
    textItems: listByLessons[64],
    additionConsult: true,
  },
  {
    ...templateObsh,
    image: 'mardon/3',
    name: 'Мардон Модебадзе',
    title: 'обществознание 96&nbsp;уроков',
    price: priceByLessons[96],
    textItems: listByLessons[96],
    additionConsult: true,
  },

  {
    ...templateGeografiya,
    image: 'nai/1',
    title: 'География 4&nbsp;урока',
    price: priceByLessons[4],
    textItems: listByLessons[4],
  },
  {
    ...templateGeografiya,
    image: 'nai/2',
    title: 'География 8&nbsp;уроков',
    price: priceByLessons[8],
    textItems: listByLessons[8],
  },
  {
    ...templateGeografiya,
    image: 'nai/3',
    title: 'География 16&nbsp;уроков',
    price: priceByLessons[16],
    textItems: listByLessons[16],
  },
  {
    ...templateGeografiya,
    image: 'nai/4',
    title: 'География 32&nbsp;урока',
    price: priceByLessons[32],
    textItems: listByLessons[32],
  },
  {
    ...templateGeografiya,
    image: 'nai/1',
    title: 'География 64&nbsp;урока',
    price: priceByLessons[64],
    textItems: listByLessons[64],
    additionConsult: true,
  },
  {
    ...templateGeografiya,
    image: 'nai/2',
    title: 'География 96&nbsp;уроков',
    price: priceByLessons[96],
    textItems: listByLessons[96],
    additionConsult: true,
  },

  {
    ...templateBiology,
    image: 'elen/1',
    title: 'Биология 4&nbsp;урока',
    price: priceByLessons[4],
    textItems: listByLessons[4],
  },
  {
    ...templateBiology,
    image: 'elen/2',
    title: 'Биология 8&nbsp;уроков',
    price: priceByLessons[8],
    textItems: listByLessons[8],
  },
  {
    ...templateBiology,
    image: 'elen/3',
    title: 'Биология 16&nbsp;уроков',
    price: priceByLessons[16],
    textItems: listByLessons[16],
  },
  {
    ...templateBiology,
    image: 'elen/4',
    title: 'Биология 32&nbsp;урока',
    price: priceByLessons[32],
    textItems: listByLessons[32],
  },
  {
    ...templateBiology,
    image: 'elen/1',
    title: 'Биология 64&nbsp;урока',
    price: priceByLessons[64],
    textItems: listByLessons[64],
    additionConsult: true,
  },
  {
    ...templateBiology,
    image: 'elen/2',
    title: 'Биология 96&nbsp;уроков',
    price: priceByLessons[96],
    textItems: listByLessons[96],
    additionConsult: true,
  },

  {
    ...templateHimiya,
    image: 'elen/1',
    title: 'химия 4&nbsp;урока',
    price: priceByLessons[4],
    textItems: listByLessons[4],
  },
  {
    ...templateHimiya,
    image: 'elen/2',
    title: 'химия 8&nbsp;уроков',
    price: priceByLessons[8],
    textItems: listByLessons[8],
  },
  {
    ...templateHimiya,
    image: 'elen/3',
    title: 'химия 16&nbsp;уроков',
    price: priceByLessons[16],
    textItems: listByLessons[16],
  },
  {
    ...templateHimiya,
    image: 'elen/4',
    title: 'химия 32&nbsp;урока',
    price: priceByLessons[32],
    textItems: listByLessons[32],
  },
  {
    ...templateHimiya,
    image: 'elen/1',
    title: 'химия 64&nbsp;урока',
    price: priceByLessons[64],
    textItems: listByLessons[64],
    additionConsult: true,
  },
  {
    ...templateHimiya,
    image: 'elen/2',
    title: 'химия 96&nbsp;уроков',
    price: priceByLessons[96],
    textItems: listByLessons[96],
    additionConsult: true,
  },

  {
    ...templateAnglisky,
    image: 'alesh/1',
    name: 'Елена алешина',
    title: 'английский язык 4&nbsp;урока',
    price: priceByLessons[4],
    textItems: listByLessons[4],
  },
  {
    ...templateAnglisky,
    image: 'alesh/2',
    name: 'Елена алешина',
    title: 'английский язык 8&nbsp;уроков',
    price: priceByLessons[8],
    textItems: listByLessons[8],
  },
  {
    ...templateAnglisky,
    image: 'alesh/3',
    name: 'Елена алешина',
    title: 'английский язык 16&nbsp;уроков',
    price: priceByLessons[16],
    textItems: listByLessons[16],
  },
  {
    ...templateAnglisky,
    image: 'marina/1',
    name: 'Марина веденьева',
    title: 'английский язык 32&nbsp;урока',
    price: priceByLessons[32],
    textItems: listByLessons[32],
  },
  {
    ...templateAnglisky,
    image: 'marina/2',
    name: 'Марина веденьева',
    title: 'английский язык 64&nbsp;урока',
    price: priceByLessons[64],
    textItems: listByLessons[64],
    additionConsult: true,
  },
  {
    ...templateAnglisky,
    image: 'marina/3',
    name: 'Марина веденьева',
    title: 'английский язык 96&nbsp;уроков',
    price: priceByLessons[96],
    textItems: listByLessons[96],
    additionConsult: true,
  },

  // without vpr
  {
    ...templateInform,
    image: 'alex/1',
    title: 'информатика 4&nbsp;урока',
    price: priceByLessons[4],
    textItems: listByLessons[4],
  },
  {
    ...templateInform,
    image: 'alex/2',
    title: 'информатика 8&nbsp;уроков',
    price: priceByLessons[8],
    textItems: listByLessons[8],
  },
  {
    ...templateInform,
    image: 'alex/3',
    title: 'информатика 16&nbsp;уроков',
    price: priceByLessons[16],
    textItems: listByLessons[16],
  },
  {
    ...templateInform,
    image: 'alex/1',
    title: 'информатика 32&nbsp;урока',
    price: priceByLessons[32],
    textItems: listByLessons[32],
  },
  {
    ...templateInform,
    image: 'alex/2',
    title: 'информатика 64&nbsp;урока',
    price: priceByLessons[64],
    textItems: listByLessons[64],
    additionConsult: true,
  },
  {
    ...templateInform,
    image: 'alex/3',
    title: 'информатика 96&nbsp;уроков',
    price: priceByLessons[96],
    textItems: listByLessons[96],
    additionConsult: true,
  },

  {
    ...templateLiter,
    image: 'tanya/1',
    name: 'Татьяна майская',
    title: 'литература 4&nbsp;урока',
    price: priceByLessons[4],
    textItems: listByLessons[4],
  },
  {
    ...templateLiter,
    image: 'alexa/1',
    name: 'Александра фролова',
    title: 'литература 8&nbsp;уроков',
    price: priceByLessons[8],
    textItems: listByLessons[8],
  },
  {
    ...templateLiter,
    image: 'olga/1',
    name: 'Ольга полякова',
    title: 'литература 16&nbsp;уроков',
    price: priceByLessons[16],
    textItems: listByLessons[16],
  },
  {
    ...templateLiter,
    image: 'olga/2',
    name: 'Ольга полякова',
    title: 'литература 32&nbsp;урока',
    price: priceByLessons[32],
    textItems: listByLessons[32],
  },
  {
    ...templateLiter,
    image: 'olga/3',
    name: 'Ольга полякова',
    title: 'литература 64&nbsp;урока',
    price: priceByLessons[64],
    textItems: listByLessons[64],
    additionConsult: true,
  },
  {
    ...templateLiter,
    image: 'olga/1',
    name: 'Ольга полякова',
    title: 'литература 96&nbsp;уроков',
    price: priceByLessons[96],
    textItems: listByLessons[96],
    additionConsult: true,
  },

  {
    ...templateSpanish,
    image: 'margo/1',
    title: 'испанский язык 4&nbsp;урока',
    price: priceByLessons[4],
    textItems: listByLessons[4],
  },
  {
    ...templateSpanish,
    image: 'margo/2',
    title: 'испанский язык 8&nbsp;уроков',
    price: priceByLessons[8],
    textItems: listByLessons[8],
  },
  {
    ...templateSpanish,
    image: 'margo/3',
    title: 'испанский язык 16&nbsp;уроков',
    price: priceByLessons[16],
    textItems: listByLessons[16],
  },
  {
    ...templateSpanish,
    image: 'margo/4',
    title: 'испанский язык 32&nbsp;урока',
    price: priceByLessons[32],
    textItems: listByLessons[32],
  },
  {
    ...templateSpanish,
    image: 'margo/1',
    title: 'испанский язык 64&nbsp;урока',
    price: priceByLessons[64],
    textItems: listByLessons[64],
    additionConsult: true,
  },
  {
    ...templateSpanish,
    image: 'margo/2',
    title: 'испанский язык 96&nbsp;уроков',
    price: priceByLessons[96],
    textItems: listByLessons[96],
    additionConsult: true,
  },

  {
    ...templateGerman,
    image: 'alesh/1',
    title: 'немецкий язык 4&nbsp;урока',
    price: priceByLessons[4],
    textItems: listByLessons[4],
  },
  {
    ...templateGerman,
    image: 'alesh/2',
    title: 'немецкий язык 8&nbsp;уроков',
    price: priceByLessons[8],
    textItems: listByLessons[8],
  },
  {
    ...templateGerman,
    image: 'alesh/3',
    title: 'немецкий язык 16&nbsp;уроков',
    price: priceByLessons[16],
    textItems: listByLessons[16],
  },
  {
    ...templateGerman,
    image: 'alesh/1',
    title: 'немецкий язык 32&nbsp;урока',
    price: priceByLessons[32],
    textItems: listByLessons[32],
  },
  {
    ...templateGerman,
    image: 'alesh/2',
    title: 'немецкий язык 64&nbsp;урока',
    price: priceByLessons[64],
    textItems: listByLessons[64],
    additionConsult: true,
  },
  {
    ...templateGerman,
    image: 'alesh/3',
    title: 'немецкий язык 96&nbsp;уроков',
    price: priceByLessons[96],
    textItems: listByLessons[96],
    additionConsult: true,
  },

  {
    ...templateChinese,
    image: 'adel/1',
    title: 'китайский язык 4&nbsp;урока',
    price: priceByLessons[4],
    textItems: listByLessons[4],
  },
  {
    ...templateChinese,
    image: 'adel/2',
    title: 'китайский язык 8&nbsp;уроков',
    price: priceByLessons[8],
    textItems: listByLessons[8],
  },
  {
    ...templateChinese,
    image: 'adel/1',
    title: 'китайский язык 16&nbsp;уроков',
    price: priceByLessons[16],
    textItems: listByLessons[16],
  },
  {
    ...templateChinese,
    image: 'adel/2',
    title: 'китайский язык 32&nbsp;урока',
    price: priceByLessons[32],
    textItems: listByLessons[32],
  },
  {
    ...templateChinese,
    image: 'adel/1',
    title: 'китайский язык 64&nbsp;урока',
    price: priceByLessons[64],
    textItems: listByLessons[64],
    additionConsult: true,
  },
  {
    ...templateChinese,
    image: 'adel/2',
    title: 'китайский язык 96&nbsp;уроков',
    price: priceByLessons[96],
    textItems: listByLessons[96],
    additionConsult: true,
  },

  {
    ...templateOkr,
    image: 'anna/1',
    title: 'окружающий мир 4&nbsp;урока',
    price: priceByLessons[4],
    textItems: listByLessons[4],
  },
  {
    ...templateOkr,
    image: 'anna/2',
    title: 'окружающий мир 8&nbsp;уроков',
    price: priceByLessons[8],
    textItems: listByLessons[8],
  },
  {
    ...templateOkr,
    image: 'anna/3',
    title: 'окружающий мир 16&nbsp;уроков',
    price: priceByLessons[16],
    textItems: listByLessons[16],
  },
  {
    ...templateOkr,
    image: 'anna/4',
    title: 'окружающий мир 32&nbsp;урока',
    price: priceByLessons[32],
    textItems: listByLessons[32],
  },
  {
    ...templateOkr,
    image: 'anna/1',
    title: 'окружающий мир 64&nbsp;урока',
    price: priceByLessons[64],
    textItems: listByLessons[64],
    additionConsult: true,
  },
  {
    ...templateOkr,
    image: 'anna/2',
    title: 'окружающий мир 96&nbsp;уроков',
    price: priceByLessons[96],
    textItems: listByLessons[96],
    additionConsult: true,
  },
];

// START exam cards
const examPrice = {
  64: { lesson: 1499, withoutDiscount: 1899, discount: 21 },
  32: { lesson: 1599, withoutDiscount: 1899, discount: 16 },
  16: { lesson: 1699, withoutDiscount: 1899, discount: 11 },
  10: { lesson: 1799, withoutDiscount: 1899, discount: 5 },
  4: { lesson: 1899, all: 7590, discount: 0 },
};

const examPhotosBySubject = {
  [SUBJECTS.math]: ['oleg/1', 'oleg/2', 'oleg/3', 'oleg/4', 'oleg/1'],
  [SUBJECTS.inform]: ['alex/1', 'alex/2', 'alex/3', 'alex/1', 'alex/2'],
  [SUBJECTS.rus]: ['katya/1', 'katya/2', 'katya/3', 'katya/4', 'katya/1'],
  [SUBJECTS.liter]: ['olga/1', 'olga/2', 'olga/3', 'olga/1', 'olga/2'],
  [SUBJECTS.fizika]: ['kris/1', 'kris/1', 'kris/1', 'kris/1', 'kris/1'],
  [SUBJECTS.himiya]: ['elen/1', 'elen/2', 'elen/3', 'elen/4', 'elen/1'],
  [SUBJECTS.biology]: ['elen/1', 'elen/2', 'elen/3', 'elen/4', 'elen/1'],
  // [SUBJECTS.okr]: ['anna/1', 'anna/2', 'anna/3', 'anna/4', 'anna/1'],
  [SUBJECTS.geografiya]: ['nai/1', 'nai/2', 'nai/3', 'nai/4', 'a/1'],
  [SUBJECTS.istoriya]: ['mardon/1', 'mardon/2', 'mardon/3', 'mardon/4', 'mardon/1'],
  [SUBJECTS.obsh]: ['andrey/1', 'andrey/1', 'andrey/1', 'andrey/1', 'andrey/1'],
  [SUBJECTS.anglisky]: ['alesh/1', 'alesh/2', 'alesh/3', 'alesh/1', 'alesh/2'],
  [SUBJECTS.german]: ['alesh/1', 'alesh/2', 'alesh/3', 'alesh/1', 'alesh/2'],
  [SUBJECTS.spanish]: ['margo/1', 'margo/2', 'margo/3', 'margo/4', 'margo/1'],
  [SUBJECTS.chinese]: ['adel/1', 'adel/2', 'adel/1', 'adel/2', 'adel/1'],
};

const examCards = ['ЕГЭ', 'ОГЭ'].reduce((all, exam) => {
  const isEge = exam === 'ЕГЭ';
  Object.keys(examPhotosBySubject).forEach((subject) => {
    const subjectName = subjectList.find((subj) => subj.id === subject).title;
    Object.keys(examPrice).forEach((count, index) => {
      const card = {
        subject,
        cheap: [
          { text: exam, colored: false },
          { text: subjectName, colored: false },
          { id: isEge ? TARGET.ege : TARGET.oge, text: 'Репетитор', colored: true },
        ],
        image: examPhotosBySubject[subject][index],
        // eslint-disable-next-line max-len,vue/max-len
        title: `Готовим к ${exam} 1 на 1 <br> ${subjectName} <b>${count}&nbsp;урок${count % 10 < 5 && count % 10 ? 'а' : 'ов'}</b>`,
        price: examPrice[count],
        textItems: listByLessons.exam,
        classes: { from: isEge ? 10 : 8, to: isEge ? 11 : 9 },
        exam: true,
      };
      all.push(card);
    });
  });
  return all;
}, []);
// END exam cards

// START free
const freeCard = {
  cheap: [
    { id: TARGET.free, text: 'Бесплатно', colored: false },
    { text: 'Все предметы', colored: true },
  ],
  image: 'free/1',
  title: 'Пробный урок с репетитором по&nbsp;любому предмету',
  textItems: [
    'Определите цели и получите диагностику по уровню подготовки',
    'Сможете закрыть непонятные вопросы по занятию',
    'Получите индивидуальный план обучения',
  ],
  free: true,
};
// END free

export const allCards = [...cards, ...examCards, freeCard];

export default allCards;
